import ar from './ar.json';
import en from './en.json';

/**
 * The Trust module's catalogue, registered from `app.config.tsx` under the
 * `trust` namespace — `shared/i18n` never imports a module (W2).
 */
export const trustCatalogs = { ar, en };
